module.exports = __webpack_public_path__ + "img/tag-user.6a5f9b2a.svg";